import { useState, useEffect } from 'react'
import AuthService from 'services/auth'
import cutileiApi from 'services/cutileiApi'
import { logApiError } from 'services/apiError'
import ItemTabs from 'components/ItemTabs'
import LoyaltyCardList from 'components/Lists/LoyaltyCardList'
import CustomerServiceList from 'components/Lists/CustomerServiceList'
import { ReactComponent as Loading } from 'icons/loading2.svg'
import { Container, FilterContainer } from '../styles'
import { DateTime } from 'luxon'

export default function CustomerLoyaltyCards ({ customer }) {
  const TAB_LIST = [
    {label: 'Cartões', value: 'customer_cards'},
    {label: 'Recompensas', value: 'rewards'}
  ]

  const [loading, setLoading] = useState (true)
  const [customerLoyaltyCards, setCustomerLoyaltyCards] = useState ([])
  const [customerRewards, setCustomerRewards] = useState ([])
  const [activeTab, setActiveTab] = useState (TAB_LIST[0].value)
  const businessId = AuthService.getBusinessId ()
  const token = AuthService.getToken ()

  const requestConfig = {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  }

  useEffect (() => {
    getData ()
  }, [customer, activeTab])

  const getData = async () => {
    try {
      setLoading (true)

      if (activeTab === 'customer_cards') {
        const { data: customerLoyaltyCards } = await cutileiApi.get (
          `/businesses/${businessId}/customers/${customer.id}/loyalty_cards`,
          requestConfig
        )
  
        setCustomerLoyaltyCards (customerLoyaltyCards.sort (orderLoyaltyCards))
      } else {
        const { data: customerRewards } = await cutileiApi.get (
          `/customers/${customer.id}/services?business_id=${businessId}&earned_from=loyalty_card`,
          requestConfig
        )
        setCustomerRewards (customerRewards)
      }
    } catch (error) {
      logApiError (error)
    } finally {
      setLoading (false)
    }
  }

  const orderLoyaltyCards = (a, b) => {
    const dateA = a.created_at ? DateTime.fromISO (a.created_at).toMillis () : 0
    const dateB = b.created_at ? DateTime.fromISO (b.created_at).toMillis () : 0

    return dateB - dateA
  }

  return (
    <Container>
      <FilterContainer>
        <ItemTabs
          tabs={TAB_LIST}
          selectedTab={activeTab}
          onTabChange={setActiveTab}
          containerStyle={{paddingTop: 0}}
          tabWidth={130}
        />
      </FilterContainer>
      {loading ? <Loading style={{marginBlock: 20}}/> : (
        <Container>
          {activeTab === 'customer_cards' && (
            <LoyaltyCardList
              cards={customerLoyaltyCards}
              onDelete={card => setCustomerLoyaltyCards (prevCards => (
                prevCards.filter (c => c.id !== card.id)
              ))}
            />
          )}
          {activeTab === 'rewards' && (
            <CustomerServiceList
              customer={customer}
              customerServices={customerRewards}
              emptyStateText='Este cliente ainda não possui recompensas resgatadas'
            />
          )}
        </Container>
      )}
    </Container>
  )
}
